<template>
  <spinner
    :loading="show"
    :text="msg"
  />
</template>

<script>
  import spinner from './spinner/Spinner'

  export default {
    name: 'Loading',
    data() {
      return {
        show: true,
        msg: '正在拼命加载...'
      }
    },
    components: {
      spinner
    }
  }
</script>
